{
	"branches": {
		"header": "Alle Filiaal",
		"name": "Naam",
		"type": "Type",
		"contactPerson": "Contactpersoon",
		"headOffice": "Hoofdkantoor",
		"onlineShop": "Online-Shop",
		"hint": "Alle Filiaal",
		"byName": "Sorteer op Naam",
		"byHeadOffice": "Sorteer op Hoofdkantoor",
		"byContactPerson": "Sorteer op Contactpersoon",
		"byType": "Sorteer op Type",
		"byOnlineShop": "Sorteer op Online-Shop"
	},
	"branchDetails":{
		"title": "FiliaalDetails",
		"masterData": "Stamgegevens",
		"name": "Naam van de winkel en rechtsvorm",
		"headOffice": "Hoofdkantoor",
		"ownerOrManager": "Eigenaar / Directeur",
		"contactPerson": "Contactpersoon",
		"streetAndHouseNo": "Straat, huisnummer",
		"country": "Land",
		"postalCode": "PC",
		"place": "Plaats",
		"phone": "Telefoon",
		"fax": "Fax",
		"email": "E-Mail",
		"website": "Website",
		"onlineShop": "Online-Shop",
		"openHours": "Openingstijden",
		"weekday": "Werkdag",
		"morning": "Voormiddag",
		"afternoon": "Namiddag",
		"sunday": "Zondag",
		"monday": "Maandag",
		"tuesday": "Dinsdag",
		"wednesday": "Woensdag",
		"thursday": "Donderdag",
		"friday": "Freitag",
		"saturday": "Zaterdag",
		"timePlaceHolder": "HH:MM",
		"namePlaceHolder": "Foto voorbeeld e.K.",
		"ownerOrManagerPlaceHolder": "Jens Mustermann eigenaar, Max Mustermann directeur",
		"contactPersonPlaceHolder": "Konrad contactperoon",
		"streetAndHouseNoPlaceHolder": "Voorbeeldstraat 1",
		"postalCodePlaceHolder": "01234",
		"placePlaceHolder": "Plaats",
		"phonePlaceHolder": "01234 / 567890",
		"faxPlaceHolder": "01234 / 567890",
		"emailPlaceHolder": "info@foto-mustermann.de",
		"websitePlaceHolder": "www.foto-mustermann.de",
		"messages": {
			"deleteSuccess": "Het filiaal {{branchName}} is succesvol verwijderd",
			"deleteMessage": " ",
			"deleteTitle": "Wil je echt de filiaal verwijderen?",
			"deleteFailure": "Filiaal kon niet worden verwijderd",
			"emptyList": "De lijst is leeg"
		},
		"buttons":{
			"confirm": "Ok",
			"cancel": "Afbreken",
			"edit": "Verander",
			"delete": "Verwijderen",
			"save": "Overnemen",
			"add": "Creëer"
		},
		"countryCodes": {
			"DE": "Duitsland",
			"NL": "Nederland",
			"AT": "Oostenrijk",
			"IT": "Italië",
			"CH": "Zwitserland"
		},
		"branchId": "Filial-ID",
		"branchVat": "Takbelastingnummer",
		"branchSearchExport": "Winkel in dealer zoeken",
		"branchVendorReporting": "Vendor Reporting relevant"
	},
	"branchesCreate": {
		"title": "Filiale maken",
		"createFailure": "Filiaal kon niet worden aangemaakt.",
		"createSuccess": "Het filiaal {{branchName}} is succesvol aangemaakt."
	},
	"branchesEdit": {
		"title": "Filiale edit",
		"createFailure": "Filiaal kon niet verwerkt worden",
		"createSuccess": "Het filiaal {{branchName}} is succesvol gewijzigd."
	},
	"breadcrumbs": {
		"details": "Filiaal Übersicht",
		"child": "{{name}}"
	}
}
